export enum GraphQueryTreeErrorCode {
    WRONG_JUMPS = "WRONG_JUMPS",
}